import type { PageProps } from 'gatsby';
import React from 'react';
import Header from '../components/Header';
import Footer from './Footer';

const Layout: React.FC<PageProps> = (props) => (
  <>
    <Header>Menú</Header>
    {props.children}

    <Footer />
  </>
);

export default Layout;
